import SvgIcon from '@mui/material/SvgIcon';
import { styled } from '@mui/material';
export var Component = styled(SvgIcon)(function (_a) {
    var theme = _a.theme;
    return ({
        '&.MuiSvgIcon-fontSizeSmall': {
            fontSize: '20px',
        },
        '&.MuiSvgIcon-fontSizeMedium': {
            fontSize: '24px',
        },
        '&.MuiSvgIcon-fontSizeLarge': {
            fontSize: '35px',
        },
    });
});
